import { render, staticRenderFns } from "./PreventivaResultadosPanel.vue?vue&type=template&id=f7a6092a&scoped=true&"
import script from "./PreventivaResultadosPanel.vue?vue&type=script&lang=js&"
export * from "./PreventivaResultadosPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a6092a",
  null
  
)

export default component.exports